import React from 'react'
import { storiesOf } from '@storybook/react'

import Coin from 'components/Coin'

storiesOf('Coin', module)
  .addDecorator((story) => (
    <div style={{ padding: 16 }}>{story()}</div>
  ))
  .add('default', () => (
    <>
      <Coin variant="h1" value={3876} />
      <Coin variant="h2" value={3876} />
      <Coin variant="h3" value={3876} />
      <Coin variant="h4" value={3876} />
      <Coin variant="h5" value={3876} />
      <Coin variant="h6" value={3876} />
      <Coin variant="subtitle1" value={3876} />
      <Coin variant="subtitle2" value={3876} />
      <Coin variant="body2" value={3876} />
      <Coin variant="body1" value={3876} />
      <Coin variant="button" value={3876} />
      <Coin variant="caption" value={3876} />
      <Coin variant="overline" value={3876} />
    </>
  ))
